module.exports = __webpack_public_path__ + "static/bf99a9c3379278465ecb0bd66a93cc607d64ffd57bf1d8da0cef6857a1c66c98-5f983526ee8455f808f98a7d918f10fe.jpeg";